import { Component, Input, SimpleChanges } from '@angular/core';
import { RowCell, GridCell, ContentElement } from '../../../models/sections-model';

@Component({
  selector: 'kve-product-cell-content',
  templateUrl: './product-cell-content.component.html',
  styleUrls: ['./product-cell-content.component.scss']
})
export class ProductCellContentComponent {
  @Input() cell:RowCell|GridCell;
  @Input() preview:boolean;
  contentElements:ContentElement[];


  ngOnChanges(changes: SimpleChanges): void {
    if(changes["cell"]){
      this.contentElements = this.cell.contentElements
    }
  }
}
